import { RefObject, useEffect } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

// Moves focus into a Select's open content on open: prefers the search input, falls back to the first list item.
// Desktop only — on mobile, Vaul's drawer portal severs the cmdk-root from its items, so focused items
// can't receive cmdk's keyboard nav events. Until the Select architecture is reworked to mount <Command>
// inside the portal, mobile autofocus would land on a non-navigable element, so we skip it entirely.
// Uses cmdk's stable data attributes so no refs need to be plumbed across the list/item boundary.
export default function useSelectAutoFocus(contentRef: RefObject<HTMLElement | null>, isOpen: boolean) {
    const isDesktop = useIsDesktop()

    useEffect(() => {
        if (!isOpen || !isDesktop) {
            return
        }
        const frame = requestAnimationFrame(() => {
            const root = contentRef.current
            if (!root) {
                return
            }
            const searchInput = root.querySelector<HTMLInputElement>("[cmdk-input]")
            if (searchInput) {
                searchInput.focus()
                return
            }
            const firstItem = root.querySelector<HTMLElement>("[cmdk-item]")
            firstItem?.focus()
        })
        return () => cancelAnimationFrame(frame)
    }, [isOpen, isDesktop, contentRef])
}
